<div class="form-group">
    <div class="custom-control custom-checkbox terms-of-use-checkbox">
        <input type="checkbox" class="custom-control-input" [ngClass]="{'is-invalid': invalid}" [(ngModel)]='value'
            [id]="id" />
        <label class="custom-control-label" [for]="id">
            {{prefix}} <a class="text-primary" (click)="actionLink($event)">{{label}}</a>{{postfix}}
        </label>
    </div>
</div>